// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root,
:host {
    /* Primitive tokens */
    --gw-width-0: 0px;
    --gw-width-025: 1px;
    --gw-width-050: 2px;
    --gw-width-100: 4px;
    --gw-width-150: 6px;
    --gw-width-200: 8px;
    --gw-width-300: 12px;
    --gw-width-400: 16px;
    --gw-width-500: 20px;
    --gw-width-600: 24px;
    --gw-width-800: 32px;
    --gw-width-1000: 40px;
    --gw-width-1200: 48px;
    --gw-width-1600: 64px;
    --gw-width-2000: 80px;
    --gw-width-2400: 96px;
    --gw-width-2800: 112px;
    --gw-width-3200: 128px;
}
`, "",{"version":3,"sources":["webpack://./src/themes/default_v2/width.css"],"names":[],"mappings":"AAAA;;IAEI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;AAC1B","sourcesContent":[":root,\n:host {\n    /* Primitive tokens */\n    --gw-width-0: 0px;\n    --gw-width-025: 1px;\n    --gw-width-050: 2px;\n    --gw-width-100: 4px;\n    --gw-width-150: 6px;\n    --gw-width-200: 8px;\n    --gw-width-300: 12px;\n    --gw-width-400: 16px;\n    --gw-width-500: 20px;\n    --gw-width-600: 24px;\n    --gw-width-800: 32px;\n    --gw-width-1000: 40px;\n    --gw-width-1200: 48px;\n    --gw-width-1600: 64px;\n    --gw-width-2000: 80px;\n    --gw-width-2400: 96px;\n    --gw-width-2800: 112px;\n    --gw-width-3200: 128px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
